var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 98,
    viewBox: "0 0 292 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bgblur_0_5233_7230_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -67.8693,
    y: -67.8693,
    width: 427.739,
    height: 233.739
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(33.93px)",
      height: "100%",
      width: "100%"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 67.8693,
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.837 35.3714C124.519 35.3714 127.586 36.703 130.041 39.3691C132.496 42.0351 133.723 45.3601 133.723 49.3441C133.723 53.3281 132.496 56.6531 130.041 59.319C127.586 61.9851 124.519 63.3168 120.837 63.3168C117.617 63.3168 114.932 62.2176 112.784 60.0219V72.6135H105.141V36.0112H112.784V38.6691C114.932 36.4733 117.617 35.3741 120.837 35.3741V35.3714ZM114.651 54.0444C115.895 55.305 117.456 55.9339 119.328 55.9339C121.201 55.9339 122.762 55.305 124.005 54.0444C125.249 52.7839 125.872 51.2171 125.872 49.3441C125.872 47.471 125.249 45.9042 124.005 44.6437C122.762 43.3831 121.201 42.7541 119.328 42.7541C117.456 42.7541 115.895 43.3831 114.651 44.6437C113.407 45.9042 112.784 47.471 112.784 49.3441C112.784 51.2171 113.404 52.7839 114.651 54.0444Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.603 62.677V25H143.247V62.677H135.603Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.723 63.3159C154.924 63.3159 151.867 62.2824 149.558 60.2124C147.248 58.1425 146.094 55.4053 146.094 52.0011V36.0105H153.737V50.9538C153.737 52.4523 154.194 53.6581 155.104 54.5687C156.014 55.4792 157.223 55.9359 158.721 55.9359C160.219 55.9359 161.422 55.4792 162.326 54.5687C163.228 53.6581 163.682 52.4523 163.682 50.9538V36.0105H171.325V52.0011C171.325 55.4081 170.18 58.1452 167.887 60.2124C165.593 62.2824 162.54 63.3159 158.721 63.3159H158.723Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.544 35.3713C209.543 35.3713 211.943 36.2736 213.742 38.0782C215.54 39.883 216.44 42.2755 216.44 45.256V62.6767H208.796V47.5557C208.796 46.1091 208.376 44.947 207.531 44.0693C206.686 43.1915 205.557 42.754 204.144 42.754C202.73 42.754 201.485 43.2052 200.566 44.1076C199.645 45.0099 199.185 46.1939 199.185 47.6568V62.6767H191.542V47.5557C191.542 46.1091 191.116 44.947 190.262 44.0693C189.41 43.1915 188.278 42.754 186.862 42.754C185.447 42.754 184.202 43.2052 183.283 44.1076C182.362 45.0099 181.903 46.1939 181.903 47.6568V62.6767H174.26V36.0084H181.903V38.5622C183.879 36.4349 186.411 35.3685 189.497 35.3685C191.288 35.3685 192.882 35.7295 194.279 36.4541C195.675 37.1787 196.801 38.1959 197.651 39.5056C199.833 36.7467 202.799 35.3685 206.546 35.3685L206.544 35.3713Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246 49.4452C246 50.364 245.949 51.1652 245.847 51.846H225.957C226.436 53.3445 227.278 54.5202 228.488 55.3707C229.7 56.2238 231.137 56.6476 232.807 56.6476C234.24 56.6476 235.544 56.3659 236.72 55.8053C237.895 55.2448 238.824 54.5366 239.504 53.6862L244.644 58.1296C243.195 59.7646 241.432 61.0362 239.352 61.9493C237.272 62.8602 235.022 63.3168 232.603 63.3168C228.36 63.3168 224.817 61.9685 221.98 59.2672C219.142 56.5683 217.723 53.2104 217.723 49.1909C217.723 46.6206 218.341 44.2773 219.576 42.1663C220.812 40.0554 222.522 38.3956 224.702 37.1843C226.884 35.9757 229.303 35.3714 231.963 35.3714C235.968 35.3714 239.308 36.7085 241.984 39.3827C244.661 42.057 245.998 45.4121 245.998 49.4479L246 49.4452ZM231.864 41.9612C230.432 41.9612 229.18 42.3905 228.105 43.2518C227.032 44.1131 226.299 45.2835 225.908 46.7628H237.897C237.471 45.2643 236.722 44.0885 235.647 43.2382C234.574 42.3878 233.313 41.9612 231.864 41.9612Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 25.0035V43.9013L53.7444 50.6551V31.7571L72.5436 31.8202L65.8028 25.0631L47.0036 25L47 25.0035ZM81.2022 40.1187V57.1812L74.4579 50.4276V33.3651L81.2022 40.1187ZM62.3989 58.9568H79.429L72.6881 52.1997H55.6579L62.3989 58.9568ZM90.787 66.6983V49.7219L84.0428 42.9682V61.8661L65.2435 61.8031L71.9843 68.5601L88.985 68.6171L92.5708 72.2092L94.8669 72.538L94.4295 70.3474L90.787 66.6983Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5233_7230_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12);
export default __webpack_public_path__ + "static/media/Group (12).6c3b43113e05c339767972a2bdafa905.svg";
export { ForwardRef as ReactComponent };